<template>
  <div class="main-display-container">
    <div v-if="isLoggedIn && currentAccessLevel != 'unknown'">
      <div v-if="viewSelection" class="row">
        <div class="col-12 metric-search-box">
          <div class="selection-container">
            <div>
              <div class="selection-title">
                <div style="font-size: 55px; font-weight: bold;">Metrics</div>
                <div>Select year and program name to view metrics</div>
              </div>
              <div
                style="background-color: #ffffff; box-shadow: 5px 6px 10px 0px #ccc;padding: 20px; margin-top: 28px;"
              >
                <ProgramSelection :mode="'full'" @paramsChange="onParamsChange"></ProgramSelection>
              </div>
            </div>
            <div>
              <img src="../assets/img/matrics_landing-page_image.png" alt="loading image..." />
            </div>
          </div>
        </div>
      </div>
      <div v-if="viewMetric" class="row someclass2">
        <dir class="col-12" style="margin: 0;">
          <MetricDataTable
            @paramsChange="onParamsChange"
            :metricData="tableData"
            :jsonData="jsonData"
            v-if="tableData"
            ref="MyTable"
          ></MetricDataTable>
        </dir>
      </div>
    </div>
    <div v-else>
      <div class="jumbotron jumbotron-fluid">
        <div class="container">
          <!-- <h1 class="display-4">Program Analysis & Reports</h1> -->
          <br />
          <div v-if="isLoggedIn">
            <p
              class="lead"
            >You don't have sufficient permissions to access this information. Please Contact the administrator</p>
          </div>
          <div v-else>
            <p class="lead">Please Login to continue.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MetricDataTable from "./MetricDataTable";
import ProgramSelection from "./ProgramSelection";

export default {
  name: "MetricsDisplay",
  methods: {
    ...mapActions(["getData", "resetOverlay"]),
    onParamsChange() {
      this.goToMetricView();
      this.getData().then(() => {
        this.tableData = this.currentFormatedData;
        this.jsonData = this.currentData;
      });
      this.resetOverlay();
    },
    goToMetricView() {
      this.viewSelection = false;
      this.viewMetric = true;
    }
  },
  computed: mapGetters([
    "currentProgram",
    "currentData",
    "currentFormatedData",
    "currentYear",
    "isLoggedIn",
    "currentUserName",
    "currentUserGroups",
    "currentAccessLevel"
  ]),
  data: function() {
    return {
      tableData: false,
      jsonData: false,
      viewSelection: true,
      viewMetric: false
    };
  },
  components: {
    MetricDataTable,
    ProgramSelection
  },
  created() {}
};
</script>

<style >
.top3 {
  margin-top: 1%;
}
html,
body {
  height: 100%;
  overflow: hidden;
}
.container-fluid {
  height: 100%;
  overflow-y: hidden; /* don't show content that exceeds my height */
}
.someclass2 {
  overflow: auto;
  height: 100%;
}
</style>

<style scoped>
.main-display-container,
.metric-search-box {
  background-color: #eeeeee;
  min-height: calc(100vh - 86px);
}
.selection-title {
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  align-self: center;
}
.selection-container {
  display: flex;
  justify-content: space-between;
  /* flex-direction: column; */
  align-items: center;
  /* height: 91vh */
  flex-direction: column;
}
.container-fluid {
  background-color: whitesmoke;
}

.metric-search-box {
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
</style>



